import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Modal, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import Inputmask from 'inputmask';
import SvgIcon from 'react-icons-kit';
import {download} from 'react-icons-kit/fa/download';
import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import $ from 'jquery';
import {fetchRequest} from '../../../libs/fetchRequest';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

var Config = require('../../../config');
var socket = "";

class ModalSamples extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getNextNumber = this.getNextNumber.bind(this);
		this.onSave = this.onSave.bind(this);
		this.validateInput = this.validateInput.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.clear = this.clear.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.sampleSelected = this.sampleSelected.bind(this);
		this.handleTypeAheadChange = this.handleTypeAheadChange.bind(this);
		this.saveExtraction = this.saveExtraction.bind(this);

		this.state = {
			show: false,
			entry_date:"",
			entry_hour:"",
			sample_number:"",
			sample_date:"",
			sample_hour:"",
			origin:"",
			sample_person:"",
			petition_id:"",
			convoke_places:[],
			convoke_places_id:"",
			samples_id:"",
			maternal_flag:false,
			mothers_name:"",
			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			samples:[],
			sample:"",
			showForm: false,
			patient_id:"",
			disableSave:false,

			preview_print:{},
			no_apto: false,
			reasons:[],
			reason_id:"",
			reject_id:"",
			observations:"",
			name:"",
			group_rh:"",
			pat_chang_date_sample:{},
			register_sample:true,
			show_samples:false,
			screen:"",
			service:"",
			user:"",//sessionStorage.getItem('user_name'),
			volume:"",
			medical_staff:"",
			medicals:[],
			tube_type:"",
			tube_types:[],
			arm:"",
			arms:[],
			vein:"",
			veins:[],
			vol:"",
			medical_staff_id:"",
		}

	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#entry_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#sample_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		this.props.onRef(this);

		socket= this.props.socket !== undefined && this.props.socket !== ""  ? this.props.socket : new WebSocket("wss://localhost:2018");

		if(socket.readyState !== socket.OPEN){
			//socket.send("initfp");
		}

		socket.onerror = (event)=> {
			console.log(event);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.Error === "No hay impresora configurada para imprimir")
				swal('¡Error!', res.Error, 'error');
		}
	}

	getServerTime(type){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
            	this.props.waiting.handleClose();
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-');
			var hours = this.getHourFormat(aux[1]);

			if(type === 'entry'){
				this.setState({
					entry_date: date,
					entry_hour:hours,
				});
			}else{
				this.setState({
					entry_date: date,
					entry_hour:hours,
					sample_date:date,
					sample_hour: hours
				});
			}

				

			this.props.waiting.handleClose();
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;
		var value = e.target.value;

		this.setState({
			[e.target.name]: e.target.value
		});

		if(campo === 'sample'){
			setTimeout(()=>{
				this.onUpdate(true);
			}, 500);
		}else{
			if(value !== ""){
				setTimeout(()=>{
					this.showCtrlError(campo);

				}, 500);
			}
		}
	}

	getPlaces(){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=operatives&health_facilities_id='+
				sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		}).then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        	}
    	}).then(response => {
			this.setState({
		      convoke_places: response
		    });
		});
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	async handleShow(petition_id, patient_id, name, group_rh, screen='list', service=""){
		this.getServerTime();
		this.getPlaces();

		var response = await fetchRequest({
            url:'lookups/order_by?type=TUBE_TYPE&option=name'
        });

        if(response !== undefined){
            this.setState({tube_types: response});
		}

		response = await fetchRequest({
            url:'medical_staff?option=mainInfo&type=NURSE'
        });
        if(response !== undefined){
            this.setState({medicals: response});
		}
		
		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=arm_type&option=name',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
            });
        }})
		.then(response => {
			this.setState({arms: response});
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=VEIN_TYPE&option=actives&order=false',{
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
        }})
		.then(response => {
			this.setState({veins: response});
		});
		
		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_CHANG_DATE_SAMPLE',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_chang_date_sample: response
			});
		})

		fetch(Config.default.apiGateway.URL+'lookups?type=rejection_reasons_samples&option=actives&order=true',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				reasons: response
			});
		})
		
		this.setState({
			show: true,
			petition_id: petition_id,
			patient_id: patient_id,
			name:name,
			group_rh:group_rh,
			disableSave:false,
			register_sample:screen === 'list' || screen === 'assign' ? true : false,
			screen:screen,
			service:service,
			showForm: screen === 'extraction' ? true : false
		});

		this.props.waiting.handleShow('Cargando...');
		var urlApi = 'petitions/get_samples?petition_id='+petition_id;
		if(screen === 'extraction'){
			urlApi = 'samples/by_donation?donation_id='+petition_id;
		}

		fetch(Config.default.apiGateway.URL+urlApi, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');	
				});
				
			}
		}).then(response => {
			if(response !== undefined){
				if(Array.isArray(response)){
					if(response.length > 0){
						var last = response.length - 1;
						this.setState({
							samples: response,
							sample:response[0].sample.id,
							user: response[0].user,
							medical_staff: response[0].taked_by,
							
						});
						
						this.onUpdate();
					}
				}else{
					var sample = response;
					
					var item = [{
						sample,
						incident:response.samples_has_incidents.length > 0 ? response.samples_has_incidents[0] : null
					}];

					this.setState({
						samples: item,
						sample:item[0].sample.id,
						user: item[0].user_id,
					});

					this.onUpdate();
				}
			}
		});		

		if(screen !== 'extraction'){
			fetch(Config.default.apiGateway.URL+'petitions/get_old_samples?petition_id='+petition_id, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');	
					});
					
				}
			}).then(response => {
				if(response !== undefined){
					if(response.length > 0){
						var samples = this.state.samples;
						response.map((s)=>{
							samples.push(s);
						});

						this.setState({samples:samples});

						//this.onUpdate();
					}
				}
			})
		}
		if(screen !== 'extraction'){

			setTimeout(()=>{
				var selector_entry = document.getElementById("entry_hour");
				var selector_sample = document.getElementById("sample_hour");
				var im = new Inputmask("--:--");
			
				if(selector_entry !== null){
					im.mask(selector_entry);
					im.mask(selector_sample);	
				}
			},500)
		}
	}

	handleClose(){
		this.setState({
			show: false,
			entry_date:"",
			entry_hour:"",
			sample_number:"",
			sample_date:"",
			sample_hour:"",
			origin:"",
			sample_person:"",
			petition_id:"",
			convoke_places:[],
			convoke_places_id:"",
			samples_id:"",

			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			samples:[],
			sample:"",
			showForm:false,
			preview_print:{},
			name:"",
			group_rh:"",
			show_samples:false
		});

		if(this.state.register_sample){
			this.props.getList();
		}	
	}

	getNextNumber(){
		fetch(Config.default.apiGateway.URL+'samples/get_next_number?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
			'&sample_type=PATIENT',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({sample_number:response});
				this.showCtrlError('sample_number');
			}
		})
	}

	onSave(){
		if(this.state.showForm){
			if(this.isValidForm()){
				var obj = {};
				var api = '';
				var method = '';
				var date = moment(this.state.entry_date+' '+this.state.entry_hour, 'YYYY-MM-DD H:mm').format('MM-DD-YYYY H:mm');
				
				if(this.state.samples_id !== ""){
					api = 'samples/update_patient_sample';
					method = 'PUT';

					var index = this.state.samples.findIndex(obj => obj.sample.id === this.state.samples_id
						);
					obj = this.state.samples[index];
					if(obj.petition_has_sample !== null && obj.petition_has_sample !== undefined){						
						obj.petition_has_sample.petitions_id = this.state.petition_id;
						obj.petition_has_sample.entry_date = date;
					}else{
						obj.petition_has_sample ={
							petitions_id: this.state.petition_id,
							entry_date: date,
							samples_id: this.state.samples_id,
						};
					}	

					obj.sample.convoke_places_id =  parseInt(this.state.convoke_places_id, 10);
					obj.sample.id = this.state.samples_id;
					obj.sample.number = this.state.sample_number;
					obj.sample.petition_id = this.state.petition_id;
					obj.sample.taked_by = this.state.sample_person;
					obj.sample.patient_id = this.state.patient_id;
					obj.sample.mothers_name = this.state.mothers_name;
					obj.sample.maternal_flag = this.state.maternal_flag;
					
					obj.sample.tube_type = this.state.tube_type;
					obj.sample.arm = this.state.arm;
					obj.sample.vein = this.state.vein;
					obj.sample.volume = this.state.vol;
					obj.sample.temperature = this.state.temperature;
					obj.sample.medical_staff_id = this.state.medical_staff_id;


					if(this.state.reason_id !== ""){
						obj.sample.samples_has_incidents = [{
							rejection_reason:this.state.reason_id,
							samples_id:this.state.samples_id,
							observations: this.state.observations
						}];
					}

					if(this.state.reject_id !== ""){

						obj.sample.samples_has_incidents.id = this.state.reject_id;
					}
				
				}else{
					obj.sample = {
						convoke_places_id: parseInt(this.state.convoke_places_id, 10),
						timestamp: date,
						sample_number: this.state.sample_number,
						taked_by: this.state.sample_person,
						sample_types_id: null,
						patient_id:this.state.patient_id,
						mothers_name: this.state.mothers_name,
						maternal_flag: this.state.maternal_flag,
						tube_type: this.state.tube_type,
						arm: this.state.arm,
						vein: this.state.vein,
						vol: this.state.vol,
						temperature: this.state.temperature,
						medical_staff_id: this.state.medical_staff_id,
					};
					if(this.state.reason_id !== ""){
						obj.sample.samples_has_incidents = [{rejection_reason:this.state.reason_id, observations: this.state.observations}];
					}
					obj.petition_has_sample ={
						petitions_id: this.state.petition_id,
						entry_date: date
					};
					
					api = 'samples/patient_sample?health_facilities_id='+
							sessionStorage.getItem('health_facilities_id');
					method = 'POST';

				}

				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+api, {
					method:method,
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res =>{
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						//this.handleClose();
						if(method === 'POST'){
							this.setState({samples_id:response.sample.id, disableSave:true });
						}
						
						swal('Correcto', 'Registro guardado correctamente', 'success');
					}
				});

			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			swal('Error', 'Debe seleccionar una muestra o generar un nuevo registro.', 'error');
		}	
	}

	printSampleLabel(e, id){
		e.preventDefault();

		fetch(Config.default.apiGateway.URL+'html_templates?health_facilities_id='+
			sessionStorage.getItem("health_facilities_id")+'&file_type=label_samples&extraction_type=',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
			if(res.ok){
			  return res.json();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
			  });
			}})
		.then(response => {
			if(response.res === 0){
				swal('¡Error!', "No se ha definido ninguna etiqueta para el \"Registro de Muestras\"", 'error');
			}else{
				this.props.waiting.handleShow('Imprimiendo...');

				var obj ={};
				obj.health_facilities_id = sessionStorage.getItem("health_facilities_id");
				obj.id = id;
				obj.file_type = "label_samples";
				obj.nEtiqueta = [];
				obj.reference_id = this.state.petition_id;

				var print = false;

				if(this.state.preview_print.value !== "NO"){
					print = true;
				}

				var document = this.props.printLabel(obj, print)

				if(document !== undefined){
					this.props.waiting.handleClose();
					this.handleClose();
					//this.setState({ show: false});
				}else{
					this.props.waiting.handleClose();
				}
				/*fetch(Config.default.apiGateway.URL+"labelsEditor", {
					method : 'post',
					body:JSON.stringify(obj),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.blob();
					}else{
					  res.text().then(function(result) {
						swal('¡Error', result, 'error');
						return;
					  });
					}
				})
				.then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = function() {
								var base64data = reader.result;  
								var aux = base64data.split(',');
								socket.send('{"Operacion":"print", "Type":"label_sample_patients", "File": "'+aux[1]+'"}');
							}
						}
						
						this.handleClose();
						//this.setState({ show: false});
					}
				})*/
			}
		});
	}

	isValidForm() {
		const inputs = document.querySelectorAll('.sample-form');
	    let isFormValid = true;
		
	    inputs.forEach(input => {
			if(input.required){
				const isInputValid = this.showCtrlError(input.name);
				
				if (!isInputValid) {
					isFormValid = false;
				}
					
			}
				
		});		
	    
	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		
		if(control !== null){
			
			if(this.state[refName] !== undefined){
				
				if(this.state[refName] === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}else{
				
				
				if(control.value === ""){
					
					control.classList.add('error');
					res = false
				}else{
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
						
					}
					res = true;
				}
			}
		}
		

		return res;
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			form.elements[index + 1].focus();
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	clear(){
  		this.getServerTime();
  		this.getPlaces();
  		
  		this.setState({
			sample_number:"",
			origin:"",
			sample_person:"",
			convoke_places_id:"",

			antibodies_required: null,
			donation_id: "",
			donor_id: "",
			number: "",
			offers_id: "",
			sample_types_id:"",
			storage_ubication_id:"",
			validated:"",
			validation_status:"",

			sample:"",
			showForm: true,	
			samples_id:"",
			maternal_flag:false,
			mothers_name:"",
			volume:"",
			medical_staff:"",
			tube_type:"",
			arm:"",
			vein:"",
			vol:"",
			medical_staff_id:"",
		});

  	}

  	onUpdate(setSample = false){		  
  		var sample_id = parseInt(this.state.sample);
  		var index = this.state.samples.findIndex(obj => obj.sample.id === sample_id);
		this.getPlaces();		

  		if(index !== -1){
			  var item = this.state.samples[index];

  			if(item.petition_has_sample !== null && item.petition_has_sample !== undefined){
  				
  				this.setState({
  					entry_date: item.petition_has_sample.entry_date.split('T')[0],
		           	entry_hour: moment(item.petition_has_sample.entry_date.split('T')[1], 'HH:mm').format('HH:mm'),
		           	sample_date: item.sample.timestamp.split('T')[0],
		           	sample_hour: moment(item.sample.timestamp.split('T')[1], 'HH:mm').format('HH:mm'),
  				});
  			}else{
  				this.getServerTime('entry');
				this.setState({
  					sample_date: item.sample.timestamp.split('T')[0],
		           	sample_hour: moment(item.sample.timestamp.split('T')[1], 'HH:mm').format('HH:mm'),
  				});
	  				
			  }
			  
			console.log(item)

  			if(item.incident === null){
  				this.setState({
					no_apto:false,
					reason_id:"",
					observations:""
				})
  			}else{
  				this.setState({
					no_apto:true,
					reason_id:item.incident.rejection_reason,
					observations:item.incident.observations,
					reject_id:item.incident.id
				})
  			}

	  		this.setState({
	           antibodies_required: item.sample.antibodies_required,
	           donation_id:item.sample.donation_id,
	           donor_id:item.sample.donor_id,
	           sample_number: this.state.screen !== 'list' ? 
	           					!this.state.show_samples ? "" :
	           					this.state.sample !== "" ? item.sample.number : "" 
	           				: item.sample.number,
	           offers_id: item.sample.offers_id,
	           sample_types_id: item.sample.sample_types_id,
	           storage_ubication_id: item.sample.storage_ubication_id,
	           convoke_places_id: item.sample.convoke_places_id !== null ? item.sample.convoke_places_id : "" ,
	           sample_person: item.sample.taked_by,
	           validated: item.sample.validated,
	           validation_status: item.sample.validation_status,
			   samples_id: sample_id,
			   mothers_name:item.sample.mothers_name,
			   maternal_flag:item.sample.maternal_flag,
			   tube_type: item.sample.tube_type,
			   arm: item.sample.arm,
			   vein: item.sample.vein,
			   vol: item.sample.volume,
			   volume:item.sample.volume,
			   temperature: item.sample.temperature,
			   medical_staff_id: item.sample.medical_staff_id,
			   
	           //patient_id: item.sample.patient_id,
	           //sample: "",
	           //showForm:false,
			});
			
			if(this.state.showForm){
				//setTimeout(()=>{
					var index1 = this.state.medicals.findIndex(obj => obj.medical_staff.id === item.sample.medical_staff_id);
					
					if(index1 !== -1){
					
						this.handleTypeAheadChange([this.state.medicals[index1]], 'medical_staff_id');
						if(this._typeahead_delivered !== undefined){
							this._typeahead_delivered.getInstance().setState({
								text:this.state.medicals[index1].medical_staff.lastname1+' '+
									(this.state.medicals[index1].medical_staff.lastname2 !== null ? this.state.medicals[index1].medical_staff.lastname2 : "")+' '+
									this.state.medicals[index1].medical_staff.names
							});
						}
					}
				//}, 500);
			}

  		}else{
  			//swal('Error', 'Debe seleccionar una muestra.', 'error');
  		}
  	}

  	onChecked(e){
		if(e.target.name === "no_apto"){
  			this.setState({no_apto: e.target.checked ? true : false});
		}else if(e.target.name === 'show_samples'){
			if(this.state.samples.length === 0){
				swal('Error', 'La petición no tiene muestras archivadas, tiene que generar una nueva', 'error');
				this.setState({show_samples: false});
			}else{
				this.setState({
					show_samples: e.target.checked ? true : false,
					showForm: e.target.checked ? true : false,
					sample: this.state.sample !== "" ? this.state.sample : ""
				});
			}

			setTimeout(() => {
				this.onUpdate();	
			}, 500);
			
			
		}else{
			this.setState({maternal_flag: e.target.checked ? true : false});
		}
  	}

  	sampleSelected(){
  		var e = {
  			target:{
  				name:'sample_selected_id',
  				value: this.state.sample
  			}
  		}
  		this.props.handleChange(e);

  		this.handleClose();
	}
	  
	_handleSearch = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
	    });
    }
    
    handleTypeAheadChange(values, name){        
        if(values.length > 0){
    		this.setState({
    			isLoading:false,
                [name]: name === 'origin' ? values[0].id : values[0].medical_staff.id,
                index:0,                
	        });     	
        }
    }

	saveExtraction(){
		if(this.state.showForm){
			if(this.isValidForm()){
				var obj = {};
				var api = '';
				var method = '';
				var date = moment(this.state.entry_date+' '+this.state.entry_hour, 'YYYY-MM-DD H:mm').format('MM-DD-YYYY H:mm');

				obj = {
					id: this.state.samples_id,
					donation_id: this.state.petition_id,
					donor_id: this.state.patient_id,
					timestamp: date,
					mothers_name: this.state.mothers_name,
					maternal_flag: this.state.maternal_flag,
					tube_type: this.state.tube_type,
					arm: this.state.arm,
					vein: this.state.vein,
					volume: this.state.vol,
					temperature: this.state.temperature,
					medical_staff_id: this.state.medical_staff_id,
				};
				if(this.state.reason_id !== ""){
					obj.samples_has_incidents = [{rejection_reason:this.state.reason_id, observations: this.state.observations}];
				}
				
				
				api = 'samples/update_donation_sample';
				method = 'PUT';

				this.props.waiting.handleShow('Guardando...');
				fetch(Config.default.apiGateway.URL+api, {
					method:method,
					body: JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res =>{
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.handleClose();
												
						swal('Correcto', 'Registro guardado correctamente', 'success');
					}
				});
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}

			
		}else{
			swal('Error', 'Debe seleccionar una muestra o generar un nuevo registro.', 'error');
		}
		
	}

	render(){
		const {t} = this.props;

		return (
			<Modal backdrop="static" keyboard={false} dialogClassName="modal-samples" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Datos de la Muestra</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
			        		<form noValidate>
								{this.state.screen !== 'extraction' &&
								<div>
									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-4" style={{marginTop:'5px'}}>
											<label className="color-font">Número de muestra </label>
											<span style={{display:'block'}}>{this.state.sample_number}</span>
										</div>
										<div className="col-xs-12 col-sm-4">
											<label className="color-font">Fecha de muestra </label>
											<span style={{display:'block'}}>
												{moment(this.state.sample_date).format('DD/MM/YYYY')}
											</span>
										</div>
										<div className="col-xs-12 col-sm-4" style={{marginTop:'5px'}}>
											<label className="color-font">Volumen</label>
											<span style={{display:'block'}}>{this.state.volume}</span>
										</div>
									</div>
									<div className="col-xs-12">
										<div className="col-xs-12 col-sm-4" style={{marginTop:'5px'}}>
											<label className="color-font">Tomada por </label>
											<span style={{display:'block'}}>{this.state.medical_staff}</span>
										</div>
										<div className="col-xs-12 col-sm-4" style={{marginTop:'5px'}}>
											<label className="color-font">Paciente/Donador</label>
											<span style={{display:'block'}}>{this.state.name}</span>
										</div>
										<div className="col-xs-12 col-sm-4">
											<label className="color-font">Grupo & RH </label>
											<span style={{display:'block', fontSize:'20px', color:'red'}}>{this.state.group_rh}</span>
										</div>			        				
									</div>
									{this.state.mothers_name !== "" ?
										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-4" style={{marginTop:'5px'}}>
												<label className="color-font">Nombre de Madre </label>
												<span style={{display:'block'}}>{this.state.mothers_name}</span>
											</div>
										</div>
									:null}		        			

									{this.state.samples.length > 0?
										<div className="col-xs-12">
											<div className="col-xs-12">
												<input type="checkbox" name="show_samples" checked={this.state.show_samples} onChange={this.onChecked} 
													checked={this.state.show_samples}/>
												<span style={{marginLeft:'10px'}}>Asociar muestra antigua</span>
											</div>
										</div>
									:null}

									<div className="col-xs-12">
										{this.state.show_samples ? 
											<div className="col-xs-12 col-sm-4">
												<span className="span-min">Muestras</span>
												<select className="form-control" name="sample" id="sample"
													onChange={this.handleChange} value={this.state.sample}>
													<option value="">Seleccionar...</option>
													{this.state.samples.map((s, i)=>{
														return <option key={i} value={s.sample.id}>
															{s.sample.number} - {moment(s.sample.timestamp, 'YYYY-MM-DD H:mm').format('DD/MM/YYYY HH:mm')} 
														{s.sample.expired_date !== null ? ' - '+ 'Caducada' : ''}
														</option>
													})}
												</select>
											</div>
										:null} 
											
										
										{this.state.register_sample ? 
											<div className="col-xs-12 col-sm-2" style={{marginTop:"18px"}}>
												<button type="button" className="btn btn-info" onClick={this.clear}>
													Nuevo
												</button>
											</div>
										:null}
										<br/><hr style={{width:"100%", marginTop:"3em"}}/>
									</div>
								
								</div>}
			        			{this.state.showForm ? 
			        				<div className="form-sample">
			        					<div className="col-xs-12">
						        			<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Fecha</span>
						        				<input type="date" name="entry_date" id="entry_date" className="form-control"
						        					value={this.state.entry_date} onChange={this.handleChange} required 
													onKeyPress={this.validateInput} 
													disabled={this.state.screen === 'extraction' ? false :
														this.state.pat_chang_date_sample.value !== undefined ?
															this.state.pat_chang_date_sample.value === 'NO' ?
																true
															: false
														: true
													}
												/>
						        			</div>
						        			<div className="col-xs-12 col-sm-2">
						        				<span className="span-min">Hora</span>
						        				<input id="entry_hour" name="entry_hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
													data-inputmask-placeholder="-" value={this.state.entry_hour || ""} onChange={this.handleChange}
													required className="form-control" onKeyPress={this.validateInput} 
													disabled={this.state.screen === 'extraction' ? false :
														this.state.pat_chang_date_sample.value !== undefined ?
															this.state.pat_chang_date_sample.value === 'NO' ?
																true
															: false
														: true
													}
												/>
						        			</div>
											{this.state.screen !== 'extraction' &&
												<div className="col-xs-11 col-sm-5">
													<span className="span-min">Muestra Número</span>
													<input type="string" className="form-control input-hour" 
														name="sample_number" id="sample_number" required value={this.state.sample_number}
														onChange={this.handleChange} onKeyPress={this.validateInput} />
												</div>
											}
						        			
						        			{this.state.register_sample ?
						        				<div className="col-xs-1 col-sm-1" style={{textAlign:'right'}}>
													<Button className="btn btn-info btn-xs" style={{marginTop:"21px"}} type="button" 
														title="Generar Número de Donación" onClick={this.getNextNumber} >
														<SvgIcon icon={download} style={{paddingTop:"3px"}}/>
													</Button>
												</div>
											:null}
						        		</div>
						        		<div className="col-xs-12">
						        			<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Tipo de Tubo</span>
						        				<select name="tube_type" id="tube_type" value={this.state.tube_type}
						        					className="form-control" onChange={this.handleChange} 
						        					onKeyPress={this.validateInput} 
						        				>
													<option value="">Seleccione...</option>
													{this.state.tube_types.map((tube, i)=>
														<option key={i} value={tube.key}>{tube.name}</option>
													)}
												</select>
						        			</div>
						        			<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Brazo</span>
						        				<select name="arm" id="arm" value={this.state.arm}
						        					className="form-control" onChange={this.handleChange} 
						        					onKeyPress={this.validateInput} 
						        				>
													<option value="">Seleccione...</option>
													{this.state.arms.map((t)=>
														<option key={t.id} value={t.key} >{t.name}</option>
													)}
												</select>
						        			</div>
											<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Vena</span>
						        				<select name="vein" id="vein" value={this.state.vein}
						        					className="form-control" onChange={this.handleChange} 
						        					onKeyPress={this.validateInput} 
						        				>
													<option value="">Seleccione...</option>
													{this.state.veins.map((t)=>
														<option key={t.id} value={t.key} >{t.name}</option>
													)}
												</select>
						        			</div>					        			

						        		</div>

										<div className="col-xs-12 form-group">
											<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Volumen</span>
						        				<input type="number" name="vol" id="vol" value={this.state.vol}
						        					className="form-control input-hour" onChange={this.handleChange} 
						        					onKeyPress={this.validateInput} 
						        				/>
						        			</div>	
											<div className="col-xs-12 col-sm-4">
						        				<span className="span-min">Temperatura</span>
						        				<input  type="number"  name="temperature" id="temperature" value={this.state.temperature}
						        					className="form-control input-hour" onChange={this.handleChange} 
						        					onKeyPress={this.validateInput} 
						        				/>
						        			</div>	
										</div>

						        		<div className="col-xs-12 form-group">
						        			<div className="col-xs-12 col-sm-6">
						        				<span className="span-min">Tomada por</span>
						        				<AsyncTypeahead
													labelKey={(option) => `${
														option.medical_staff.lastname1+' '+(option.medical_staff.lastname2 !== null ? option.medical_staff.lastname2 : "")+' '+option.medical_staff.names
													}`}
													minLength={0}
													name="medical_staff"
													id="medical_staff" 
													inputProps={{
														autoComplete:"off",
														name:'medical_staff_id',
														id:'medical_staff_id',
														required:true
													}}
													options={this.state.medicals}
													onSearch={this._handleSearch}
													onChange={(e)=>this.handleTypeAheadChange(e, 'medical_staff_id')}
													ref={ref => this._typeahead_delivered = ref}
													delay={600}
													isLoading={this.state.isLoading}
													paginationText="Mostrar mas resultados..."
												/>
						        			</div>
											{this.state.screen !== 'extraction' &&
												<div className="col-xs-12 col-sm-6">
													<span className="span-min">Lugar de Colecta</span>
													<select className="form-control"
														value={ this.state.convoke_places_id } onKeyPress={this.validateInput} 
														onChange={ this.handleChange } autoFocus={true}
														name="convoke_places_id" id="convoke_places_id" 
													>
															<option value="">Seleccionar...</option>
														{this.state.convoke_places.map((t)=>
															<option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>
														)}
													</select>
												</div>
											}
						        		</div>

										<div className="col-xs-12">
											{this.state.screen !== 'extraction' &&
												<div className="col-xs-12">
													<input type="checkbox" name="maternal_name" checked={this.state.maternal_flag} onChange={this.onChecked} />
													<span style={{marginLeft:'10px'}}>Muestra materna</span>
												</div>
											}

											{this.state.maternal_flag ?											
												<div className="col-xs-12">
													<span className="span-min">Nombre de Madre</span>
													<input type="text" name="mothers_name" id="mothers_name" value={this.state.mothers_name}
													className="form-control" onChange={this.handleChange} />	
												</div>	
											:null}
						        			<div className="col-xs-12">
												<input type="checkbox" name="no_apto" checked={this.state.no_apto} onChange={this.onChecked} />
												<span style={{marginLeft:'10px'}}>Muestra no apta</span>
											</div>
										</div>

										{this.state.no_apto ?
											<div className="col-xs-12">
												<div className="col-xs-4">
													<span className="span-min">Motivo</span>
													<select className="form-control" id="reason_id" name="reason_id" value={this.state.reason_id}
														onChange={this.handleChange}>
														<option value="">Seleccione...</option>
														{this.state.reasons.map((r, i)=>(
															<option key={i} value={r.key}>{r.name}</option>
														))}
													</select>												
												</div>
											</div>
										:null}
							        	
							        	{this.state.no_apto ?
											<div className="col-xs-12">
												<div className="col-xs-12">
													<span className="span-min">Observaciones</span>
													<textarea className="form-control" value={this.state.observations}
														onChange={this.handleChange} name="observations" id="observations"
														style={{width:"100%",resize:"none"}}></textarea>
												</div>
											</div>
										:null}
											

										{this.state.screen !== 'extraction'  &&
											<div className="col-xs-12" style={{marginTop:'10px', textAlign:'center'}}>
												<button className="toolIcon" disabled={this.state.samples_id === ""} 
													onClick={(e)=>this.printSampleLabel(e, this.state.samples_id)}>
													<SvgIcon size={40} icon={ic_local_offer} />
													<div className="col-xs-12">
														<span>{t('toolbar.labels')}</span>
													</div>
												</button>
											</div>
										}

			        				</div>
			        			: null}
						        		
				        	</form>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} 
		        	onClick={this.state.screen === 'extraction' ? this.saveExtraction : this.state.register_sample ? this.onSave : this.sampleSelected} 
		        	disabled={this.state.disableSave} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}
}
export default translate('translations') (ModalSamples);